"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./../../features/base/app/middleware");
require("./../../features/menu/middleware");
